import React, { ReactNode } from 'react';

export type LegendPropsT = {
  title: ReactNode;
  className?: string;
};

export type FieldsetPropsT = {
  children: ReactNode;
  className?: string;
  legendProps?: LegendPropsT;
};
export type FieldsetT = React.FC<FieldsetPropsT>;

export const Fieldset: FieldsetT = ({
  children,
  className,
  legendProps,
}) => (
  <fieldset className={className}>
    {legendProps?.title && (
      <legend className={legendProps.className}>
        {legendProps.title}
      </legend>
    )}

    {children}
  </fieldset>
);
